// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3gP9t","log":"ModalInventoryLogs_log__3TRE0","date":"ModalInventoryLogs_date__2ktzJ","userName":"ModalInventoryLogs_userName__2813u"};